export function isRelativeUrl(url: string): boolean {
  if (typeof url == "undefined") return false;

  let valid = false;
  const base = window.location.origin;

  // relative url will start with only one /
  if (url.startsWith("/") && url.charAt(1) !== "/") {
    valid = URL.canParse(url, base);
  }

  return valid;
}
